import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const DIAS  = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];

function padZ(n) { return String(n).padStart(2, '0'); }
function ymd(d)  { return `${d.getFullYear()}-${padZ(d.getMonth()+1)}-${padZ(d.getDate())}`; }
function fmtHora(h) {
  const [hh, mm] = h.split(':');
  const hr = parseInt(hh);
  return `${padZ(hr > 12 ? hr - 12 : hr || 12)}:${mm} ${hr < 12 ? 'AM' : 'PM'}`;
}
function fmtFechaLarga(ymdStr) {
  const [y,m,d] = ymdStr.split('-').map(Number);
  return new Date(y, m-1, d).toLocaleDateString('es-EC', { weekday:'long', day:'numeric', month:'long', year:'numeric' });
}

export default function ReagendarCita() {
  const { token } = useParams();

  const [cargando,   setCargando]   = useState(true);
  const [error,      setError]      = useState('');
  const [cita,       setCita]       = useState(null);

  const [fecha,      setFecha]      = useState('');
  const [hora,       setHora]       = useState('');
  const [slots,      setSlots]      = useState([]);
  const [loadSlots,  setLoadSlots]  = useState(false);
  const [diaCerrado, setDiaCerrado] = useState(false);

  const [confirmando, setConfirmando] = useState(false);
  const [errorEnvio,  setErrorEnvio]  = useState('');
  const [exito,       setExito]       = useState(null);

  const hoy = new Date(); hoy.setHours(0,0,0,0);
  const [calMes,  setCalMes]  = useState(hoy.getMonth());
  const [calAnio, setCalAnio] = useState(hoy.getFullYear());

  // ── Cargar datos de la cita por token ─────────────────────────────────────
  useEffect(() => {
    axios.get(`${API}/public/reagendar/${token}`)
      .then(r => {
        setCita(r.data);
        setCargando(false);
      })
      .catch(e => {
        setError(e.response?.data?.error || 'Enlace inválido o cita no encontrada');
        setCargando(false);
      });
  }, [token]);

  // ── Cargar slots al elegir fecha ──────────────────────────────────────────
  const fetchSlots = useCallback(() => {
    if (!fecha || !cita) return;
    setLoadSlots(true);
    setSlots([]);
    setHora('');
    setDiaCerrado(false);
    axios.get(`${API}/public/${cita.codigo_tenant}/disponibilidad?fecha=${fecha}&servicio_id=${cita.servicio_id}&excluir_cita_id=${cita.cita_id}`)
      .then(r => {
        const data = r.data;
        if (data && typeof data === 'object' && !Array.isArray(data)) {
          setSlots(data.slots || []);
          setDiaCerrado(data.cerrado || false);
        } else {
          setSlots(Array.isArray(data) ? data : []);
          setDiaCerrado(false);
        }
      })
      .catch(() => { setSlots([]); setDiaCerrado(false); })
      .finally(() => setLoadSlots(false));
  }, [fecha, cita]);

  useEffect(() => { fetchSlots(); }, [fetchSlots]);

  // ── Confirmar reagendamiento ───────────────────────────────────────────────
  const handleConfirmar = async () => {
    setErrorEnvio('');
    setConfirmando(true);
    try {
      await axios.put(`${API}/public/reagendar/${token}`, { nueva_fecha: fecha, nueva_hora: hora });
      setExito({ nueva_fecha: fecha, nueva_hora: hora });
    } catch (e) {
      setErrorEnvio(e.response?.data?.error || 'Error al reagendar. Intenta de nuevo.');
    } finally {
      setConfirmando(false);
    }
  };

  // ── Calendario ────────────────────────────────────────────────────────────
  function diasDelMes() {
    const primero = new Date(calAnio, calMes, 1);
    const ultimo  = new Date(calAnio, calMes + 1, 0);
    const celdas  = [];
    for (let i = 0; i < primero.getDay(); i++) celdas.push(null);
    for (let d = 1; d <= ultimo.getDate(); d++) celdas.push(new Date(calAnio, calMes, d));
    return celdas;
  }
  function mesAnterior() {
    if (calMes === 0) { setCalMes(11); setCalAnio(a => a-1); }
    else setCalMes(m => m-1);
  }
  function mesSiguiente() {
    if (calMes === 11) { setCalMes(0); setCalAnio(a => a+1); }
    else setCalMes(m => m+1);
  }

  // ─────────────────────────────────────────────────────────────────────────
  if (cargando) return (
    <div style={s.page}>
      <div style={s.loadingBox}>
        <div style={s.spinner} />
        <p style={{ color:'#6b7280', marginTop:'1rem' }}>Cargando...</p>
      </div>
    </div>
  );

  if (error) return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ textAlign:'center', padding:'2rem 1rem' }}>
          <div style={{ fontSize:'3rem', marginBottom:'0.75rem' }}>⚠️</div>
          <h2 style={{ color:'#dc2626', fontSize:'1.2rem', margin:'0 0 0.5rem' }}>No se puede reagendar</h2>
          <p style={{ color:'#6b7280', fontSize:'0.9rem', lineHeight:'1.6' }}>{error}</p>
        </div>
      </div>
      <p style={s.powered}>Powered by FactuTracks</p>
    </div>
  );

  if (exito) return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ textAlign:'center', padding:'2rem 1rem' }}>
          <div style={{ fontSize:'3.5rem', marginBottom:'0.75rem' }}>✅</div>
          <h2 style={{ color:'#065f46', fontSize:'1.3rem', fontWeight:'800', margin:'0 0 0.35rem' }}>
            ¡Cita reagendada!
          </h2>
          <p style={{ color:'#6b7280', fontSize:'0.9rem', marginBottom:'1.5rem' }}>
            Tu cita en <strong>{cita.negocio}</strong> ha sido actualizada.
          </p>
          <div style={s.confirmBox}>
            <Row label="Servicio" value={cita.servicio_nombre} />
            <Row label="Nueva fecha" value={fmtFechaLarga(exito.nueva_fecha)} />
            <Row label="Nueva hora" value={fmtHora(exito.nueva_hora)} />
            <Row label="Cliente" value={cita.cliente_nombre} />
          </div>
          <p style={{ color:'#9ca3af', fontSize:'0.8rem', marginTop:'1rem' }}>
            Si necesitas volver a cambiarla, usa el enlace que te llegará al correo.
          </p>
        </div>
      </div>
      <p style={s.powered}>Powered by FactuTracks</p>
    </div>
  );

  return (
    <div style={s.page}>
      {/* Cabecera */}
      <div style={{ textAlign:'center', marginBottom:'1.25rem' }}>
        <h1 style={{ fontSize:'1.6rem', fontWeight:'800', color:'#111827', margin:0 }}>{cita.negocio}</h1>
        <p style={{ color:'#6b7280', margin:'0.25rem 0 0', fontSize:'0.9rem' }}>Reagendar mi cita</p>
      </div>

      <div style={s.card}>
        {/* Cita actual */}
        <div style={s.citaActual}>
          <p style={{ margin:'0 0 0.6rem', fontWeight:'700', color:'#374151', fontSize:'0.875rem' }}>
            📋 Tu cita actual
          </p>
          <Row label="Servicio" value={cita.servicio_nombre} />
          <Row label="Fecha" value={fmtFechaLarga(cita.fecha)} />
          <Row label="Hora" value={fmtHora(cita.hora)} />
          <Row label="Cliente" value={cita.cliente_nombre} />
        </div>

        <p style={{ fontWeight:'700', color:'#111827', fontSize:'1rem', marginBottom:'1rem', marginTop:'1.5rem' }}>
          Selecciona la nueva fecha y hora
        </p>

        {/* Calendario */}
        <div style={s.calWrap}>
          <div style={s.calHeader}>
            <button style={s.calNav} onClick={mesAnterior}>‹</button>
            <span style={{ fontWeight:'700', color:'#111827' }}>{MESES[calMes]} {calAnio}</span>
            <button style={s.calNav} onClick={mesSiguiente}>›</button>
          </div>
          <div style={s.calGrid}>
            {DIAS.map(d => <div key={d} style={s.calDayName}>{d}</div>)}
            {diasDelMes().map((d, i) => {
              if (!d) return <div key={`e${i}`} />;
              const dp = new Date(d); dp.setHours(0,0,0,0);
              const disponible = dp >= hoy;
              const seleccionado = d && ymd(d) === fecha;
              return (
                <button
                  key={i}
                  disabled={!disponible}
                  onClick={() => { setFecha(ymd(d)); setHora(''); }}
                  style={{
                    ...s.calDay,
                    ...(seleccionado ? s.calDaySelected : {}),
                    ...(!disponible ? s.calDayDisabled : {}),
                  }}
                >
                  {d.getDate()}
                </button>
              );
            })}
          </div>
        </div>

        {/* Slots */}
        {fecha && (
          <div style={{ marginTop:'1.5rem' }}>
            <p style={{ fontWeight:'600', color:'#374151', marginBottom:'0.75rem', fontSize:'0.9rem' }}>
              Horarios disponibles — {fmtFechaLarga(fecha)}
            </p>
            {loadSlots ? (
              <p style={s.empty}>Buscando horarios...</p>
            ) : diaCerrado ? (
              <div style={{ textAlign:'center', padding:'1.25rem 0' }}>
                <div style={{ fontSize:'2rem', marginBottom:'0.5rem' }}>🚫</div>
                <p style={{ fontWeight:'700', color:'#dc2626', margin:'0 0 0.25rem' }}>El negocio está cerrado este día</p>
                <p style={{ color:'#6b7280', fontSize:'0.875rem' }}>Por favor selecciona otra fecha.</p>
              </div>
            ) : slots.length === 0 ? (
              <p style={s.empty}>No hay horarios disponibles para este día.</p>
            ) : (
              <div style={s.slotsGrid}>
                {slots.map(sl => (
                  <button
                    key={sl}
                    onClick={() => setHora(sl)}
                    style={{ ...s.slotBtn, ...(hora === sl ? s.slotBtnActive : {}) }}
                  >
                    {fmtHora(sl)}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Resumen + botón confirmar */}
        {hora && (
          <div style={{ marginTop:'1.5rem' }}>
            <div style={s.resumen}>
              <p style={{ margin:0, fontSize:'0.9rem', color:'#1e40af' }}>
                <strong>{cita.servicio_nombre}</strong> · {fmtFechaLarga(fecha)} · <strong>{fmtHora(hora)}</strong>
              </p>
            </div>

            {errorEnvio && (
              <div style={s.errorMsg}>{errorEnvio}</div>
            )}

            <button
              style={{ ...s.btnPrimary, opacity: confirmando ? 0.7 : 1, marginTop:'1rem' }}
              onClick={handleConfirmar}
              disabled={confirmando}
            >
              {confirmando ? 'Guardando...' : '✅ Confirmar nuevo horario'}
            </button>
          </div>
        )}
      </div>

      <p style={s.powered}>Powered by FactuTracks</p>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', padding:'0.4rem 0', borderBottom:'1px solid #f3f4f6', fontSize:'0.875rem' }}>
      <span style={{ color:'#6b7280' }}>{label}</span>
      <span style={{ fontWeight:'600', color:'#111827', textAlign:'right', textTransform:'capitalize' }}>{value}</span>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #eff6ff 0%, #f0fdf4 100%)',
    padding: '1.5rem 1rem 3rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  card: {
    background: '#fff',
    borderRadius: '16px',
    padding: '1.75rem',
    maxWidth: '560px',
    margin: '0 auto',
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
  },
  loadingBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
  },
  spinner: {
    width: '2.5rem',
    height: '2.5rem',
    border: '3px solid #e5e7eb',
    borderTop: '3px solid #3b82f6',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
  citaActual: {
    background: '#f0f9ff',
    border: '1px solid #bae6fd',
    borderRadius: '12px',
    padding: '1rem 1.25rem',
  },
  confirmBox: {
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    padding: '1rem',
    textAlign: 'left',
  },
  calWrap: {
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  calHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.75rem 1rem',
    background: '#f9fafb',
    borderBottom: '1px solid #e5e7eb',
  },
  calNav: {
    background: 'none',
    border: '1px solid #e5e7eb',
    borderRadius: '6px',
    width: '2rem',
    height: '2rem',
    cursor: 'pointer',
    fontSize: '1rem',
    color: '#374151',
  },
  calGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    padding: '0.5rem',
    gap: '2px',
  },
  calDayName: {
    textAlign: 'center',
    fontSize: '0.7rem',
    fontWeight: '600',
    color: '#9ca3af',
    padding: '0.4rem 0',
  },
  calDay: {
    textAlign: 'center',
    padding: '0.5rem',
    borderRadius: '8px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '0.875rem',
    color: '#111827',
    fontWeight: '500',
  },
  calDaySelected: {
    background: '#3b82f6',
    color: '#fff',
    fontWeight: '700',
  },
  calDayDisabled: {
    color: '#d1d5db',
    cursor: 'default',
  },
  slotsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))',
    gap: '0.5rem',
  },
  slotBtn: {
    padding: '0.6rem',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    background: '#f9fafb',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '600',
    color: '#374151',
  },
  slotBtnActive: {
    background: '#3b82f6',
    color: '#fff',
    borderColor: '#3b82f6',
  },
  resumen: {
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '10px',
    padding: '0.85rem 1rem',
    color: '#1e40af',
  },
  btnPrimary: {
    width: '100%',
    padding: '0.875rem',
    background: '#3b82f6',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: '700',
    cursor: 'pointer',
  },
  errorMsg: {
    background: '#fee2e2',
    color: '#dc2626',
    border: '1px solid #fca5a5',
    borderRadius: '8px',
    padding: '0.75rem 1rem',
    fontSize: '0.875rem',
    marginTop: '0.75rem',
  },
  empty: {
    color: '#9ca3af',
    fontSize: '0.875rem',
    textAlign: 'center',
    padding: '1.5rem 0',
  },
  powered: {
    textAlign: 'center',
    color: '#d1d5db',
    fontSize: '0.75rem',
    marginTop: '1.5rem',
  },
};
